/**
 * Postgres raises foreign_key_violation (SQLSTATE 23503) when a delete would remove rows that
 * financial history still references. These deletes are refused on purpose (issue #128), so the
 * raw constraint error is replaced with a message the user can act on.
 */
const FOREIGN_KEY_VIOLATION = '23503';

export function toDeleteBlockedError(error: unknown, message: string): unknown {
  if ((error as { code?: string } | null)?.code === FOREIGN_KEY_VIOLATION) {
    return new Error(message);
  }
  return error;
}
